var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.707 396.293c.36.36.388.928.083 1.32l-.083.094-14 14c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094.616-.617c-.547-.356-.909-.974-.909-1.676v-8c0-1.105.895-2 2-2h8c.702 0 1.32.362 1.676.909l2.617-2.616c.39-.39 1.024-.39 1.414 0zm.101 3.313c.034.027.065.058.092.094.065.087.1.192.1.3v8c0 .276-.224.5-.5.5-.108 0-.213-.035-.3-.1L316 406v2c0 1.105-.895 2-2 2h-4.586l10.394-10.394zM307 400c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z",
    transform: "translate(-304 -396)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamOff);
export default __webpack_public_path__ + "static/media/cam-off.1405458560e77212c0729f3cc6377f98.svg";
export { ForwardRef as ReactComponent };